(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsPollsController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'LangService', 'NotificationFactory'];

  function reports ($scope, $http, $timeout, ngTableParams, LangService, NotificationFactory) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'menu.reports.polls' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    	$scope.vm = vm;

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    vm.table_trs = [];
    vm.validator = false;

    vm.loading = true;
    vm.types = [
      {
        'id': 'operator',
        'name': 'Operador'
      }
      // {
      //     "id": 'client',
      //     "name": "Cliente"
      // },
      // {
      //     "id": 'day',
      //     "name": "Dia"
      // }
    ];
    vm.current_type = vm.types[0];

    vm.changeType = function (type) {
      vm.current_type = type;
      reload(false);
    }

    $http.get(apiUrl + '/polls')
      .then(function ({ data }) {
        vm.polls = data;
      }, function ({ data }) { console.log(data) })
    // vm.poll = {};
    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      poll_id: null
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.table = new ngTableParams({
      page: 1,
      total: 50
    }, {
      getData: function ($defer, params) {
        params.total(gdata.total);
        $defer.resolve(gdata.result.operators);
      }
    });

    var gdata = {};
    vm.validate = function () {
      vm.validator = false;
      if (!vm.poll) {
        vm.validator = true;
      }
    }
    function reload (isClick) {
      vm.validator = false;

      if ((vm.poll < 0 || !vm.poll)) {
        if (isClick) {
          vm.validator = true;
          return;
        }
        return;
      }

      vm.loading = true;
      gdata = {};
      vm.filters.poll_id = vm.poll.id;
      $http.get(apiUrl + '/reports/polls', {
        // params: params.url()
        params: {
          type: vm.current_type.id,
          filters: vm.filters
        }
      })
        .then(function ({ data }) {
          // params.total(data.total);
          // $defer.resolve(data.result);
          if (data.success === false) {
            notifSet.addNotification({
              title: vm.labels.error,
              content: data.error_message,
              color: 'alert',
              autoclose: 3000
            });
            $scope.labels = null;
            $scope.series = null;
            $scope.data = null;

            vm.table_trs = {};

            gdata = { result: {}, total: 0 };

            vm.table.reload(false);
            vm.loading = false;

            return;
          }

          vm.date = data.date;
          var series = [];
          var all = [];
          var labels = [];
          var tr_labels = [];

          for (var operator in data.result.operators) {
            series.push(operator);
            var current = [];
            labels = [];
            tr_labels = [];

            for (var hour in data.result.operators[operator]) {
              labels.push(hour);
              tr_labels.push(hour);
              current.push(data.result.operators[operator][hour]);
            }

            all.push(current);
          }

          $scope.labels = labels;
          $scope.series = series;
          $scope.data = all;

          var totals = {
            qty: 0,
            polls_qty: 0,
            not_answers_qty: 0,
            answers: {}
          };
          var grand_total = 0;
          for (var key in data.result.operators) {
            var total = 0;
            var key_qty = 0;
            if (typeof data.result.operators[key].qty !== 'undefined') {
              key_qty = data.result.operators[key].qty;
            }
            totals.qty += parseInt(key_qty);
            totals.polls_qty += parseInt(data.result.operators[key].polls_qty);
            totals.not_answers_qty += parseInt(data.result.operators[key].not_answers[key]);
            for (var col in data.result.operators[key].answers) {
              var qty = parseInt(data.result.operators[key].answers[col]);
              if (typeof totals.answers[col] === 'undefined') {
                totals.answers[col] = 0;
              }
              totals.answers[col] += qty;
            }
            data.result.operators['Total'] = totals;
          }
          // totals["Total"] = grand_total;
          // data.result["Total"] = totals;

          vm.table_trs = data.result.labels;
          vm.total_operators = data.total;

          gdata = data;

          vm.table.reload(false);
          vm.loading = false;
        }, function (error) { console.log(error) });
    }
    reload(false);
    vm.reload = reload;

    $scope.options = {
      maintainAspectRatio: true,
      responsive: true,
      datasetFill: true,
      bezierCurve: true
    };

    vm.downloadCsv = function () {
      var csvContent = '';// "data:text/csv;charset=utf-8,";
      csvContent += vm.current_type.name;
      csvContent += ',Qtde Atendimentos';
      csvContent += ',Qtde Enquetes';
      csvContent += ',Qtde Enquetes Não Avaliadas';
      csvContent += ',Notas';
      csvContent += '\n';
      csvContent += ',,,';
      for (var i in vm.table_trs) {
        csvContent += ',' + vm.table_trs[i].value;
      }
      csvContent += '\n';
      // ,Resposta Recebida em,Resposta
      for (var operator in gdata.result.operators) {
        var arr = [
          operator
        ];
        arr.push(gdata.result.operators[operator].qty);
        arr.push(gdata.result.operators[operator].polls_qty);
        if (gdata.result.operators[operator].not_answers) { arr.push(gdata.result.operators[operator].not_answers[operator]); } else { arr.push(gdata.result.operators[operator].not_answers_qty); }

        for (var label_order in gdata.result.labels) {
          var label = gdata.result.labels[label_order];
          arr.push(gdata.result.operators[operator].answers[label.key]);
        }
        csvContent += arr.join(',');
        csvContent += '\n';
      }
      var hiddenElement = document.createElement('a');
      var blob = new Blob([csvContent], { type: 'text/csv' });
      var csvUrl = URL.createObjectURL(blob);

      var anchor = angular.element('<a/>');
      anchor.css({ display: 'none' }); // Make sure it's not visible
      angular.element(document.body).append(anchor); // Attach to document

      anchor.attr({
        href: csvUrl,
        target: '_self',
        download: moment().format('YYYY-M-D HH-MM-ss') + '-mktzap - ' + vm.labels.reportCsvTitle
      })[0].click();

      anchor.remove(); // Clean it up afterwards
      URL.revokeObjectURL(csvUrl); // Clean memory blob
      // window.open(encodeURI(csvContent));
    };

    function errorHandler (data, override_message) {
      var message = vm.labels.errorTryAgain;
      if (override_message) {
        message = override_message;
      } else {
        if (data.data && data.data.message) {
          message = data.data.message;
        }
      }
      notifSet.addNotification({ title: vm.labels.error, content: message, autoclose: '3000', color: 'alert' });
    }
  }
})();
